import getNotificationType from './helpers/getNotificationType';
import shouldDisplayNotification from './helpers/shouldDisplayNotification';
import {
  PendingNotificationsQuery,
  PendingNotificationsQueryDocument,
  PendingNotificationsQueryVariables,
} from './PendingNotificationsQuery.generated';
import translateNotification from './translateNotification';
import ALLOWED_TYPES from '../../../helpers/ALLOWED_TYPES';
import LOYALTY_TYPES from '../../../helpers/LOYALTY_TYPES';
import toJson from '@/shared/utils/toJson';

const SIX_HOURS = 3_600_000;

const getPendingNotifications: WorkerQuery = async (args) => {
  const { context, fetch, addToQueue } = args;
  const { deviceType, locale, currencyConfig, language, site } = context;
  const variables: PendingNotificationsQueryVariables = {
    deviceType,
    locale,
    language,
    isRead: false,
    allowedTypes: ALLOWED_TYPES,
    userCurrency: currencyConfig.name,
    siteFilter: { site },
  };
  const response = await fetch(PendingNotificationsQueryDocument, variables);
  const { data } = await toJson<PendingNotificationsQuery>(response);
  data?.casinoNotification?.notifications?.edges?.forEach(({ node }) => {
    if (
      LOYALTY_TYPES.includes(node?.type ?? '') &&
      !context.featureFlags.get('loyalty') &&
      !context.featureFlags.get('isLoyaltyEnabled')
    ) {
      return;
    }
    if (
      node?.type === 'UserModalNotification' &&
      node.contentType === 'reward-popup-notifications'
    ) {
      return;
    }
    addToQueue({
      data: node,
      priority: 'normal',
      type: getNotificationType(node?.type),
      dismissStrategy: LOYALTY_TYPES.includes(node?.type ?? '')
        ? { storage: 'cookie', ttl: SIX_HOURS }
        : undefined,
    });
  });
  data?.casinoNotification?.kycNotification?.edges?.forEach(({ node }) => {
    const isKyc = node?.__typename === 'CasinoNotificationKycNotification';
    if (isKyc) {
      addToQueue({ data: node, priority: 'low', type: 'kyc' });
    }
  });
  data?.casinoNotification?.nftDropRewardNotifications?.edges?.forEach(
    ({ node }) => addToQueue({ data: node, priority: 'normal', type: 'nft' }),
  );
  data?.casinoNotification?.siteNotifications?.edges?.forEach(({ node }) => {
    if (node && shouldDisplayNotification(node, context)) {
      const notification = translateNotification(node, context);
      addToQueue({
        data: notification,
        priority: 'high',
        type: 'site',
      });
    }
  });
};

export default getPendingNotifications;
